import { useState } from 'react';
import { faqs } from '@/mocks/articles';
import { FAQPageSchema } from '@/components/base/SchemaOrg';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="bg-secondary-50/50">
      <div className="max-w-3xl mx-auto px-4 md:px-6 py-16 md:py-20">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            常见问题
          </h2>
          <p className="mt-2 text-sm md:text-base text-foreground-500">
            新手妈妈最关心的问题，这里有答案
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full px-5 py-4 flex items-center justify-between text-left cursor-pointer"
                aria-expanded={openIndex === i}
              >
                <span className="text-sm md:text-base font-medium text-foreground-800 pr-4">
                  {faq.question}
                </span>
                <i
                  className={`text-lg text-foreground-400 transition-transform duration-300 w-5 h-5 flex items-center justify-center flex-shrink-0 ${
                    openIndex === i ? 'ri-subtract-line' : 'ri-add-line'
                  }`}
                ></i>
              </button>
              {openIndex === i && (
                <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
      <FAQPageSchema questions={faqs} />
    </section>
  );
}